import ProgressBarSdk from '../components/ProgressBar/corvid/ProgressBar.corvid';


const ProgressBar = {
  sdk: ProgressBarSdk
};


export const components = {
  ['ProgressBar']: ProgressBar
};

